export const routes = (prefix) => [
    {
        path: `/${prefix}/role-rights`,
        name: `${prefix}.role-rights.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.role-rights.index`,
                PageDescription: "Role rights assignment",
            },
        }
    },{
        path: `/${prefix}/role-rights_grouped`,
        name: `${prefix}.role-rights-grouped.index`,
        component: () => import('./Rights_Grouping.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.role-rights-grouped.index`,
                PageDescription: "Grouped role rights assignment",
            },
        }
    },
];
